import "./about.css"
import { Link } from "react-router-dom";

function About() {
    return(
        <div className="head" id="about">
            <div className="about11">
            <h1>
                 About Us
            </h1>
            <p>

               At <span style={{color:"#F8D47A"}}>Vijaya Traders</span>, we are redefining the path to sustainable 
               wealth through smart, ethical, and diversified investments. 
               Built on the pillars of trust, integrity, and long-term growth, 
               we believe true prosperity comes from investing in assets that 
               create real value for people and communities.<br />Our investment 
               portfolio spans across dairy farming, precious metals like gold 
               and silver, and high-value real estate — three sectors that stand
                the test of time and offer both stability and opportunity. 
                We combine traditional investment wisdom with modern market
                 insights to deliver consistent and sustainable results for our investors.
            </p>
            </div>
            <div className="contain1">
            <div className="contain">
                <div className="con1">
                    <h1 style={{color:"#F8D47A"}}>5+</h1>
                    <p className='p3'>Years of Experience</p>

                </div>
                <div className="con1">
                    <h1 style={{color:"#F8D47A"}}>10K+</h1>
                    <p className='p3'>Satisfied clients</p>
                </div>
            </div>
            <div className="contain">
                <div className="con1">
                       <h1 style={{color:"#F8D47A"}}>100%</h1>
                    <p className='p3'>guaranted results.</p>
                </div>
                <div className="con1">
                    <h1 style={{color:"#F8D47A"}}>98%</h1>
                    <p className='p3'>User Retention</p>
                </div>
            </div>
           <Link to="/inv"> <button className="bright-button" style={{color:"#C3C3C5"}}>investment Calculator </button></Link>
            </div>
        </div>
    )
}
export default About;